/* eslint-disable max-lines-per-function, no-empty-function, max-statements, max-lines */
import { useMutation } from "@apollo/client";
import { mutations } from "@bluframe/mightychroma-mightytool-graphql-schema";
import { useCallback, useMemo } from "react";
import createReviews from "./createReviews";
const { critics: { ADD_REVIEW } } = mutations;
export const initialContext = {
    areReviewsCalled: false,
    areReviewsLoading: false,
    avForumsData: undefined,
    avNirvanaData: undefined,
    avsForumData: undefined,
    bluRayAuthorityData: undefined,
    bluRayData: undefined,
    digitalBitsData: undefined,
    doBluData: undefined,
    hidefDigestData: undefined,
    highDefDiscNewsData: undefined,
    homeTheaterForumData: undefined,
    onCreateReviews: () => { },
    resetReviews: () => { },
    theaterByteData: undefined,
    whySoBluData: undefined
};
const useCreateReviewsContext = ({ avForums, avNirvana, avsForum, bluRay, bluRayAuthority, digitalBits, doBlu, hidefDigest, highDefDiscNews, homeTheaterForum, homeVideoReview, theaterByte, whySoBlu }) => {
    const [addAvForums, { called: avForumsCalled, data: avForumsData, loading: avForumsLoading, reset: avForumsReset }] = useMutation(ADD_REVIEW, {
        variables: {
            reviewAddInput: avForums.selected.review
        }
    });
    const [addAvNirvana, { called: avNirvanaCalled, data: avNirvanaData, loading: avNirvanaLoading, reset: avNirvanaReset }] = useMutation(ADD_REVIEW, {
        variables: {
            reviewAddInput: avNirvana.selected.review
        }
    });
    const [addAvsForum, { called: avsForumCalled, data: avsForumData, loading: avsForumLoading, reset: avsForumReset }] = useMutation(ADD_REVIEW, {
        variables: {
            reviewAddInput: avsForum.selected.review
        }
    });
    const [addBluRay, { called: bluRayCalled, data: bluRayData, loading: bluRayLoading, reset: bluRayReset }] = useMutation(ADD_REVIEW, {
        variables: {
            reviewAddInput: bluRay.selected.review
        }
    });
    const [addBluRayAuthority, { called: bluRayAuthorityCalled, data: bluRayAuthorityData, loading: bluRayAuthorityLoading, reset: bluRayAuthorityReset }] = useMutation(ADD_REVIEW, {
        variables: {
            reviewAddInput: bluRayAuthority.selected.review
        }
    });
    const [addDigitalBits, { called: digitalBitsCalled, data: digitalBitsData, loading: digitalBitsLoading, reset: digitalBitsReset }] = useMutation(ADD_REVIEW, {
        variables: {
            reviewAddInput: digitalBits.selected.review
        }
    });
    const [addDoBlu, { called: doBluCalled, data: doBluData, loading: doBluLoading, reset: doBluReset }] = useMutation(ADD_REVIEW, {
        variables: {
            reviewAddInput: doBlu.selected.review
        }
    });
    const [addHidefDigest, { called: hidefDigestCalled, data: hidefDigestData, loading: hidefDigestLoading, reset: hidefDigestReset }] = useMutation(ADD_REVIEW, {
        variables: {
            reviewAddInput: hidefDigest.selected.review
        }
    });
    const [addHighDefDiscNews, { called: highDefDiscNewsCalled, data: highDefDiscNewsData, loading: highDefDiscNewsLoading, reset: highDefDiscNewsReset }] = useMutation(ADD_REVIEW, {
        variables: {
            reviewAddInput: highDefDiscNews.selected.review
        }
    });
    const [addHomeTheaterForum, { called: homeTheaterForumCalled, data: homeTheaterForumData, loading: homeTheaterForumLoading, reset: homeTheaterForumReset }] = useMutation(ADD_REVIEW, {
        variables: {
            reviewAddInput: homeTheaterForum.selected.review
        }
    });
    const [addTheaterByte, { called: theaterByteCalled, data: theaterByteData, loading: theaterByteLoading, reset: theaterByteReset }] = useMutation(ADD_REVIEW, {
        variables: {
            reviewAddInput: theaterByte.selected.review
        }
    });
    const [addWhySoBlu, { called: whySoBluCalled, data: whySoBluData, loading: whySoBluLoading, reset: whySoBluReset }] = useMutation(ADD_REVIEW, {
        variables: {
            reviewAddInput: whySoBlu.selected.review
        }
    });
    const areReviewsCalled = useMemo(() => avForumsCalled ||
        avNirvanaCalled ||
        avsForumCalled ||
        bluRayCalled ||
        bluRayAuthorityCalled ||
        digitalBitsCalled ||
        doBluCalled ||
        hidefDigestCalled ||
        highDefDiscNewsCalled ||
        homeTheaterForumCalled ||
        theaterByteCalled ||
        whySoBluCalled, [
        avForumsCalled,
        avNirvanaCalled,
        avsForumCalled,
        bluRayCalled,
        bluRayAuthorityCalled,
        digitalBitsCalled,
        doBluCalled,
        hidefDigestCalled,
        highDefDiscNewsCalled,
        homeTheaterForumCalled,
        theaterByteCalled,
        whySoBluCalled
    ]);
    const areReviewsLoading = useMemo(() => avForumsLoading ||
        avNirvanaLoading ||
        avsForumLoading ||
        bluRayLoading ||
        bluRayAuthorityLoading ||
        digitalBitsLoading ||
        doBluLoading ||
        hidefDigestLoading ||
        highDefDiscNewsLoading ||
        homeTheaterForumLoading ||
        theaterByteLoading ||
        whySoBluLoading, [
        avForumsLoading,
        avNirvanaLoading,
        avsForumLoading,
        bluRayLoading,
        bluRayAuthorityLoading,
        digitalBitsLoading,
        doBluLoading,
        hidefDigestLoading,
        highDefDiscNewsLoading,
        homeTheaterForumLoading,
        theaterByteLoading,
        whySoBluLoading
    ]);
    const resetReviews = useCallback(() => {
        if (avForumsData) {
            avForumsReset();
        }
        if (avNirvanaData) {
            avNirvanaReset();
        }
        if (bluRayData) {
            bluRayReset();
        }
        if (bluRayAuthorityData) {
            bluRayAuthorityReset();
        }
        if (digitalBitsData) {
            digitalBitsReset();
        }
        if (doBluData) {
            doBluReset();
        }
        if (hidefDigestData) {
            hidefDigestReset();
        }
        if (highDefDiscNewsData) {
            highDefDiscNewsReset();
        }
        if (homeTheaterForumData) {
            homeTheaterForumReset();
        }
        if (theaterByteData) {
            theaterByteReset();
        }
        if (avsForumData) {
            avsForumReset();
        }
        if (whySoBluData) {
            whySoBluReset();
        }
    }, [
        avForumsData,
        avForumsReset,
        avNirvanaData,
        avNirvanaReset,
        avsForumData,
        avsForumReset,
        bluRayAuthorityData,
        bluRayAuthorityReset,
        bluRayData,
        bluRayReset,
        digitalBitsData,
        digitalBitsReset,
        doBluData,
        doBluReset,
        hidefDigestData,
        hidefDigestReset,
        highDefDiscNewsData,
        highDefDiscNewsReset,
        homeTheaterForumData,
        homeTheaterForumReset,
        theaterByteData,
        theaterByteReset,
        whySoBluData,
        whySoBluReset
    ]);
    const onCreateReviews = useCallback(() => {
        createReviews({
            addAvForums,
            addAvNirvana,
            addAvsForum,
            addBluRay,
            addBluRayAuthority,
            addDigitalBits,
            addDoBlu,
            addHidefDigest,
            addHighDefDiscNews,
            addHomeTheaterForum,
            addTheaterByte,
            addWhySoBlu,
            avForumsReady: Boolean(avForums.selected.url) && !homeVideoReview.avForumsId,
            avNirvanaReady: Boolean(avNirvana.selected.url) && !homeVideoReview.avNirvanaId,
            avsForumReady: Boolean(avsForum.selected.url) && !homeVideoReview.avsForumId,
            bluRayAuthorityReady: Boolean(bluRayAuthority.selected.url) &&
                !homeVideoReview.bluRayAuthorityId,
            bluRayReady: Boolean(bluRay.selected.url) && !homeVideoReview.bluRayId,
            digitalBitsReady: Boolean(digitalBits.selected.url) && !homeVideoReview.digitalBitsId,
            doBluReady: Boolean(doBlu.selected.url) && !homeVideoReview.doBluId,
            hidefDigestReady: Boolean(hidefDigest.selected.url) && !homeVideoReview.hidefDigestId,
            highDefDiscNewsReady: Boolean(highDefDiscNews.selected.url) &&
                !homeVideoReview.highDefDiscNewsId,
            homeTheaterForumReady: Boolean(homeTheaterForum.selected.url) &&
                !homeVideoReview.homeTheaterForumId,
            theaterByteReady: Boolean(theaterByte.selected.url) && !homeVideoReview.theaterByteId,
            whySoBluReady: Boolean(whySoBlu.selected.url) && !homeVideoReview.whySoBluId
        });
    }, [
        addAvForums,
        addAvNirvana,
        addAvsForum,
        addBluRay,
        addBluRayAuthority,
        addDigitalBits,
        addDoBlu,
        addHidefDigest,
        addHighDefDiscNews,
        addHomeTheaterForum,
        addTheaterByte,
        addWhySoBlu,
        avForums.selected.url,
        avNirvana.selected.url,
        avsForum.selected.url,
        bluRay.selected.url,
        bluRayAuthority.selected.url,
        digitalBits.selected.url,
        doBlu.selected.url,
        hidefDigest.selected.url,
        highDefDiscNews.selected.url,
        homeTheaterForum.selected.url,
        theaterByte.selected.url,
        homeVideoReview.avForumsId,
        homeVideoReview.avNirvanaId,
        homeVideoReview.avsForumId,
        homeVideoReview.bluRayAuthorityId,
        homeVideoReview.bluRayId,
        homeVideoReview.digitalBitsId,
        homeVideoReview.doBluId,
        homeVideoReview.hidefDigestId,
        homeVideoReview.highDefDiscNewsId,
        homeVideoReview.homeTheaterForumId,
        homeVideoReview.theaterByteId,
        homeVideoReview.whySoBluId,
        whySoBlu.selected.url
    ]);
    return useMemo(() => ({
        areReviewsCalled,
        areReviewsLoading,
        avForumsData,
        avNirvanaData,
        avsForumData,
        bluRayAuthorityData,
        bluRayData,
        digitalBitsData,
        doBluData,
        hidefDigestData,
        highDefDiscNewsData,
        homeTheaterForumData,
        onCreateReviews,
        resetReviews,
        theaterByteData,
        whySoBluData
    }), [
        areReviewsCalled,
        areReviewsLoading,
        avForumsData,
        avNirvanaData,
        avsForumData,
        bluRayAuthorityData,
        bluRayData,
        digitalBitsData,
        doBluData,
        hidefDigestData,
        highDefDiscNewsData,
        homeTheaterForumData,
        theaterByteData,
        onCreateReviews,
        resetReviews,
        whySoBluData
    ]);
};
export default useCreateReviewsContext;
